import React, { useCallback, useContext, useEffect, useState } from 'react'
import { Link, navigate } from 'gatsby'
import route from '../../utils/route'
import styles from './header.module.scss'
import MenuHeader from '../../../specific/components/headers/MenuHeader'
import AppContext from '../../context/context'
import * as UserActions from '../../context/actions/userActions'
import HeaderYellow from './HeaderYellow'
import MenuHeaderMobile from './MenuHeaderMobile'
import MenuUserMobile from './MenuUserMobile'
import CestaHeaderIcon from '../cesta/cestaHeaderIcon/CestaHeaderIcon'
import MenuAbierto from '../../assets/menu/icon_menu_mobile_abierto.svg'
import MenuCerrado from '../../assets/menu/icon_menu_mobile_cerrado.svg'
import UserMobile from '../../assets/images/menu/user.svg'
import { t } from '../../i18n'
import mainLogo from '../../../specific/images/logo.png'
import DifferentInitialRender from '../DifferentInitialRender/DifferentInitialRender'

interface HeaderProps {
  esPath: string
  caPath: string
}

const HeaderDesktop = ({ ...props }: HeaderProps) => {
  const [menuMobile, setMenuMobile] = useState(false)
  const { userInfo, dispatch } = useContext(AppContext)
  const [menu, setMenu] = useState(false)
  const { loggedIn } = userInfo

  const onLogout = useCallback(() => {
    dispatch(UserActions.logout())
  }, [])
  const onClose = useCallback(() => {
    setMenuMobile(!menuMobile)
  }, [])
  const onCloseMainMenu = useCallback(() => {
    setMenu(!menu)
  }, [])

  // Cerrar el menu si el usuario deja de estar logueado
  // (posiblemente porque ha hecho logout usando el menú mismo)
  useEffect(() => {
    if (!loggedIn && menuMobile) {
      setMenuMobile(false)
    }
  }, [loggedIn, menuMobile])

  return (
    <React.Fragment>
      <HeaderYellow {...props} />

      <div className={styles.header_black}>
        <div className={styles.header_black_wrapper}>
          {!menu && (
            <a
              href="#"
              className={styles.menu_button}
              onClick={(e) => {
                e.preventDefault()
                setMenu(!menu)
                setMenuMobile(false)
              }}>
              <MenuCerrado />
            </a>
          )}
          {menu && (
            <a
              href="#"
              className={styles.menu_button}
              onClick={(e) => {
                e.preventDefault()
                setMenu(!menu)
              }}>
              <MenuAbierto />
            </a>
          )}
          {menu && <MenuHeaderMobile close={onCloseMainMenu} {...props} />}

          <div className={styles.logo_menu}>
            <Link
              to={route('index')}
              className={styles.logo}
              title={t('rodi_motor_services')}>
              <img
                src={mainLogo}
                className={styles.logo_image}
                alt={t('rodi_motor_services')}></img>
            </Link>
          </div>

          <div className={styles.user_cesta_container}>
            <div className={styles.user}>
              {/* mobile */}
              {!menuMobile && !loggedIn && (
                <a
                  href="#"
                  className={styles.menu_button}
                  onClick={() => navigate(route('register'))}>
                  <UserMobile />
                </a>
              )}
              {!menuMobile && loggedIn && (
                <a
                  href="#"
                  className={styles.menu_button}
                  onClick={(e) => {
                    e.preventDefault()
                    setMenuMobile(!menuMobile)
                    setMenu(false)
                  }}>
                  <UserMobile />
                </a>
              )}
              {menuMobile && loggedIn && (
                <a
                  href="#"
                  className={styles.menu_button}
                  onClick={(e) => {
                    e.preventDefault()
                    setMenuMobile(!menuMobile)
                  }}>
                  <UserMobile />
                </a>
              )}
              <DifferentInitialRender
                initial={() => null}
                next={() => (
                  <MenuUserMobile
                    close={onClose}
                    onLogout={onLogout}
                    open={menuMobile}
                  />
                )}
              />
            </div>
            <CestaHeaderIcon />
          </div>
        </div>
      </div>

      <MenuHeader />
    </React.Fragment>
  )
}

const Header = ({ esPath, caPath }: HeaderProps) => {
  return (
    <header className={styles.header_wrapper}>
      <HeaderDesktop esPath={esPath} caPath={caPath} />
    </header>
  )
}

const HeaderComponent = ({ ...props }: HeaderProps) => <Header {...props} />

export default HeaderComponent
